/**
 * دالة مساعدة لضغط الصور في المتصفح قبل رفعها
 * @param {File} file - ملف الصورة الأصلي
 * @param {number} maxWidth - الحد الأقصى للعرض
 * @param {number} quality - جودة الضغط (0.1 - 1.0)
 * @returns {Promise<File>} - ملف الصورة المضغوط بتنسيق JPEG
 */
export const compressImage = (file, maxWidth = 400, quality = 0.7) => {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
        return resolve(file); // تخطي الملفات التي ليست صورا
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const scale = maxWidth / img.width;

        if (scale < 1) {
          canvas.width = maxWidth;
          canvas.height = img.height * scale;
        } else {
          canvas.width = img.width;
          canvas.height = img.height;
        }

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        ctx.canvas.toBlob((blob) => {
          if (!blob) {
              return reject(new Error('Canvas to Blob conversion failed'));
          }
          resolve(new File([blob], file.name.replace(/\.[^/.]+$/, "") + ".jpg", {
            type: 'image/jpeg',
            lastModified: Date.now()
          }));
        }, 'image/jpeg', quality);
      };
      img.onerror = (err) => reject(err);
    };
    reader.onerror = (err) => reject(err);
  });
};
